import { type HighlightsController } from '@databases/highlights';
import { createFocusBoxEffect } from '@databases/selections';
import { getService } from '@databases/service-container';
import { DatabaseLayoutType } from '@databases/types/database/view';
import { TABLE_V2_LAYOUT_ID } from '@databases/view-layout-table-v2/id';

import {
  type SelectionEffectFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export interface FocusBoxEffectFeatureDeps {
  highlightsController: HighlightsController;
}

export function createFocusBoxEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.FOCUS_BOX_EFFECT,
    type: 'effect',
    isEnabled: (ctx) =>
      ctx.layoutType === DatabaseLayoutType.TABLE ||
      ctx.layoutType === TABLE_V2_LAYOUT_ID,
    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createFocusBoxEffect(highlightsController);
    },
  };
}
